import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ShareIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00233 15.0004C7.65919 15.0004 9.00233 13.6573 9.00233 12.0004C9.00233 10.3436 7.65919 9.00043 6.00233
        9.00043C4.34548 9.00043 3.00233 10.3436 3.00233 12.0004C3.00233 13.6573 4.34548 15.0004 6.00233 15.0004Z"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5042 21.7498C18.161 21.7498 19.5042 20.4067 19.5042 18.7498C19.5042 17.093 18.161 15.7498 16.5042
         15.7498C14.8473 15.7498 13.5042 17.093 13.5042 18.7498C13.5042 20.4067 14.8473 21.7498 16.5042 21.7498Z"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5042 8.24907C18.161 8.24907 19.5042 6.90592 19.5042 5.24907C19.5042 3.59221 18.161 2.24907 16.5042
         2.24907C14.8473 2.24907 13.5042 3.59221 13.5042 5.24907C13.5042 6.90592 14.8473 8.24907 16.5042 8.24907Z"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.979 6.87219L8.52274 10.3784"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52274 13.6216L13.979 17.1278"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(ShareIcon);
